import styled from 'styled-components';
import { Button } from '../../../common/components/Button/Button';
import { LinkButton } from '../../../common/components/Button/LinkButton/LinkButton';
import { H2 } from '../../../common/components/Typography/Heading/Heading.styles';
import { Paragraph } from '../../../common/components/Typography/Paragraph/Paragraph';
import { DisplayCard } from '../../../common/components/cards/DisplayCard/DisplayCard';
import { IconHealthEngine } from '../../../common/components/icons/IconHealthEngine';
import { HeImgix } from '../../../common/components/images/HeImgix';
import { Col, FLEX_COL_TO_ROW, Row } from '../../../common/components/layout/FlexLayout';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { Breakpoint } from '../../../common/styles/constants';
import { propSwitch } from '../../../common/util/propSwitch';

export const MyCareTeamSectionTitle = styled(H2)`
  display: flex;
  margin-bottom: 0;

  ${Breakpoint.SMALL} {
    margin-bottom: 0;
  }
`;

export const MyCareTeamRow = styled(Row)`
  ${FLEX_COL_TO_ROW(Breakpoint.SMALL)}
  flex-wrap: wrap;
  margin-bottom: 42px;

  ${Col}:not(:last-child) {
    margin-bottom: 12px;
  }

  ${Breakpoint.SMALL} {
    &:not(:last-child) {
      margin-bottom: 12px;
    }

    ${Col} {
      margin-bottom: 12px;
    }
  }
`;

export const MyCareTeamCol = styled(Col)`
  min-width: calc(33.333% - 20px);

  ${Breakpoint.SMALL} {
    max-width: calc(50% - 20px);
    min-width: calc(50% - 20px);
  }
`;

export const MyCareTeamSectionHeader = styled(Row)`
  ${FLEX_COL_TO_ROW(Breakpoint.SMALL)}
  margin-bottom: 42px;
`;

export const MyCareTeamCard = styled(DisplayCard)`
  display: flex;
`;

export const MyCareTeamCardAddress = styled(Paragraph)`
  color: ${ThemeColours.mono700};
`;

export const MyCareTeamIconWrapper = styled.div`
  align-items: center;
  background-color: ${ThemeColours.primary300};
  display: flex;
  justify-content: center;
  padding: 24px;
`;

export const MyCareTeamIcon = styled(HeImgix)<{ isAvatar?: boolean }>`
  border: 1px solid ${propSwitch('isAvatar', ThemeColours.white, 'transparent')};
  border-radius: 50px;
  display: block;
`;

export const MyCareTeamCardAction = styled(Button)`
  align-self: flex-end;
  margin-top: auto;

  ${Breakpoint.SMALL} {
    width: auto;
  }
`;

export const MyCareTeamSectionIcon = styled(IconHealthEngine)`
  margin-right: 12px;
`;

export const MyCareTeamSectionEditButton = styled(LinkButton)`
  align-self: flex-end;
  width: auto;
`;
